<script lang="ts">
    import ImageSkeleton from "@components/skeletons/ImageSkeleton.svelte";
</script>

<div class="gw-tt-preview">
    <!-- Image preview -->
    <div class="gw-tt-preview__image-wrap">
        <ImageSkeleton ratio={325 / 575} />
    </div>
    <!-- Skeletons -->
    <svg
        class="gw-tt-preview__descr"
        width="299"
        height="113"
        viewBox="0 0 299 113"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect x="1" width="18" height="17" rx="4" fill="#ECECEC" />
        <rect y="44" width="110" height="17" rx="4" fill="#ECECEC" />
        <rect y="70" width="198" height="17" rx="4" fill="#ECECEC" />
        <rect y="96" width="276" height="17" rx="4" fill="#ECECEC" />
        <rect x="26" y="2" width="140" height="13" rx="6" fill="#ECECEC" />
        <circle cx="122" cy="52" r="7" fill="#20D5EC" />
        <path d="M118.5 52L121 54.5L125 50" stroke="white" />
        <rect y="29" width="299" height="1" fill="#E2E3E4" />
    </svg>
</div>

<style lang="postcss">
    .gw-tt-preview {
        position: relative;
        width: 325px;
        height: 720px;

        overflow: hidden;
        border: 1px solid #e2e3e4;
        border-radius: 7px;
        background: #ffffff;
        cursor: pointer;

        &__descr {
            width: 299px;
            margin: 14px 13px 18px 13px;
        }
    }
</style>
